import { setRealAuthHeaders, setRealUrlPrefix } from '~/session';
import { initializeActionBroadcasterElectronBindings } from '../action-broadcaster/action-broadcaster-instance';
import {
    BOLO_SEARCH_WINDOW_PATH,
    EVENTS_WINDOW_PATH,
    EVENT_SEARCH_WINDOW_PATH,
    MAP_WINDOW_PATH,
    UNIT_STATUS_SEARCH_WINDOW_PATH,
} from '../router/constants';
import { electronBridge } from './electron-bridge';

export const setupElectronWindow = async () => {
    if (electronBridge) {
        if ('isElectronRewrite' in electronBridge) {
            const headers = await electronBridge.requestAuthHeaders();
            const urlPrefix = await electronBridge.requestUrlPrefix();
            setRealAuthHeaders(headers);
            setRealUrlPrefix(urlPrefix);
        } else {
            const ipcResponse = await Promise.all([
                electronBridge.getAuthHeaders(),
                electronBridge.getUrlPrefix(),
            ]);
            setRealAuthHeaders(ipcResponse[0]);
            setRealUrlPrefix(ipcResponse[1]);
        }
        const workspaceWindowType = electronBridge.args['--workspace-window-type'];
        initializeActionBroadcasterElectronBindings(workspaceWindowType);

        // FIX: Skip window.location.replace() when the hash already matches the target route.
        // During RESYNC, window.location.reload() preserves the hash (e.g., #/events),
        // so the route is already correct. Re-navigating with replace() constructs a URL
        // that drops the versioned index filename (e.g., index_v2.3.3.html), triggering a
        // cross-document navigation that conflicts with the will-navigate handler in
        // workspace-window.ts, causing an infinite reload loop that leaves the window
        // stuck on the Loading screen. On first window open, the hash is empty so the
        // replace still runs as expected.
        const windowTypeToPath: Partial<Record<string, string>> = {
            EVENT_V2: EVENTS_WINDOW_PATH,
            EVENT_SEARCH_V2: EVENT_SEARCH_WINDOW_PATH,
            UNIT_STATUS_SEARCH_V2: UNIT_STATUS_SEARCH_WINDOW_PATH,
            BOLO_SEARCH: BOLO_SEARCH_WINDOW_PATH,
            MAP_V2: MAP_WINDOW_PATH,
        };
        const targetPath = workspaceWindowType ? windowTypeToPath[workspaceWindowType] : undefined;
        if (targetPath && window.location.hash !== `#${targetPath}`) {
            window.location.replace(`${window.location.origin}/cad-next/#${targetPath}`);
        }
    }
};
